jQuery( function( $ ) {
    'use strict';

    var $archive = $( '[data-resource-archive]' );

    var $loading       = $archive.find( '[data-resource-loading]' );
    var $type_select   = $archive.find( '[data-resource-type-select]' );
    var ajax_data      = window.vectorResourceListData || {};
    var active_request = null;
    var request_id     = 0;

    var $video_modal = $( '[data-resource-video-modal]' );
    var $video_frame = $video_modal.find( '[data-resource-video-frame]' );
    var $video_title = $video_modal.find( '#resource-video-modal-title' );
    var $video_close = $video_modal.find( '[data-resource-video-close]' ).filter( 'button' ).first();
    var video_focus  = null;
    var video_title  = $video_title.text();

    if ( ! $archive.length && ! $video_modal.length ) {
        return;
    }

    function ajaxIsAvailable() {
        return ajax_data.ajaxUrl && ajax_data.action && ajax_data.nonce;
    }

    function getSelectedMarkets() {
        var selected = [];

        $archive.find( '[data-resource-market-filter] input[type="checkbox"]:checked' ).each( function() {
            selected.push( $( this ).val() );
        } );

        return selected;
    }

    function getSelectedType() {
        if ( $type_select.length && $type_select.is( ':visible' ) ) {
            return $type_select.val() || '';
        }

        return $archive.find( '[data-resource-type-filter] .is-active' ).attr( 'data-resource-type' ) || '';
    }

    function getQueryFromControls() {
        var params = new URLSearchParams();
        var search = $.trim( $archive.find( '[data-resource-search] input[name="s"]' ).val() || '' );
        var type   = getSelectedType();

        if ( search ) {
            params.set( 's', search );
        }

        if ( type ) {
            params.set( ajax_data.typeFilterQueryVar, type );
        }

        getSelectedMarkets().forEach( function( market ) {
            params.append( ajax_data.marketFilterQueryVar + '[]', market );
        } );

        return params;
    }

    function getPublicUrl( params ) {
        var query = params.toString();

        return window.location.pathname + ( query ? '?' + query : '' ) + window.location.hash;
    }

    function syncControlsFromQuery( params ) {
        var selected_markets = params.getAll( ajax_data.marketFilterQueryVar + '[]' );
        var selected_type    = params.get( ajax_data.typeFilterQueryVar ) || '';

        $archive.find( '[data-resource-search] input[name="s"]' ).val( params.get( 's' ) || '' );
        $archive.find( '[data-resource-market-filter] input[type="checkbox"]' ).each( function() {
            $( this ).prop( 'checked', selected_markets.indexOf( $( this ).val() ) !== -1 );
        } );
        $archive.find( '[data-resource-type-filter] [data-resource-type]' ).each( function() {
            var $button = $( this );
            var active  = ( $button.attr( 'data-resource-type' ) || '' ) === selected_type;

            $button.toggleClass( 'is-active', active );
            $button.attr( 'aria-pressed', active ? 'true' : 'false' );
        } );
        $type_select.val( selected_type );
    }

    function setLoading( is_loading ) {
        $loading.prop( 'hidden', ! is_loading );
    }

    function getVideoFocusableElements() {
        return $video_modal.find( 'a[href], area[href], input:not([type="hidden"]), select, textarea, button, [tabindex]:not([tabindex="-1"])' )
            .filter( ':visible:not(:disabled)' );
    }

    function openVideoModal( $trigger ) {
        var src   = $trigger.attr( 'data-resource-video-src' ) || '';
        var title = $trigger.attr( 'data-resource-video-title' ) || video_title;

        if ( ! $video_modal.length || ! src ) {
            return;
        }

        video_focus = document.activeElement;
        $video_title.text( title );
        $video_frame.attr( 'title', title ).attr( 'src', src );
        $video_modal.removeAttr( 'hidden' ).attr( 'aria-hidden', 'false' );
        $( 'body' ).addClass( 'resource-video-modal-open' );
        $video_close.trigger( 'focus' );
    }

    function closeVideoModal() {
        if ( ! $video_modal.length ) {
            return;
        }

        $video_frame.removeAttr( 'src' ).attr( 'title', video_title );
        $video_title.text( video_title );
        $video_modal.attr( 'hidden', true ).attr( 'aria-hidden', 'true' );
        $( 'body' ).removeClass( 'resource-video-modal-open' );

        if ( video_focus && document.documentElement.contains( video_focus ) ) {
            video_focus.focus();
        }

        video_focus = null;
    }

    function openResourceCardAction( $card ) {
        var action = $card.attr( 'data-resource-card-action' );

        if ( 'video' === action ) {
            openVideoModal( $card );
        } else if ( 'link' === action ) {
            window.open( $card.attr( 'data-resource-card-url' ), '_blank', 'noopener,noreferrer' );
        }
    }

    function requestArchive( params ) {
        if ( ! ajaxIsAvailable() ) {
            window.location.assign( getPublicUrl( params || getQueryFromControls() ) );
            return;
        }

        params = params || getQueryFromControls();
        syncControlsFromQuery( params );

        var selected_markets   = params.getAll( ajax_data.marketFilterQueryVar + '[]' );
        var selected_type      = params.get( ajax_data.typeFilterQueryVar ) || '';
        var public_url          = getPublicUrl( params );
        var current_request_id  = ++request_id;
        var request_data        = {
            action:      ajax_data.action,
            nonce:       ajax_data.nonce,
            market_term: ajax_data.marketTerm || 0,
            s:           params.get( 's' ) || ''
        };

        request_data[ ajax_data.marketFilterQueryVar ] = selected_markets;
        request_data[ ajax_data.typeFilterQueryVar ]   = selected_type;

        if ( active_request ) {
            active_request.abort();
        }

        $archive.attr( 'aria-busy', 'true' ).addClass( 'is-loading' );
        setLoading( true );

        active_request = $.ajax( {
            url:      ajax_data.ajaxUrl,
            method:   'POST',
            data:     request_data,
            dataType: 'json'
        } ).done( function( response ) {
            if ( current_request_id !== request_id || ! response.success || ! response.data ) {
                return;
            }

            var $sidebar = $archive.find( '[data-resource-sidebar]' );
            var $results = $archive.find( '[data-resource-results]' );

            if ( $sidebar.length && response.data.filter_html ) {
                $sidebar.replaceWith( response.data.filter_html );
            }

            if ( $results.length && response.data.results_html ) {
                $results.replaceWith( response.data.results_html );
            }

            window.history.pushState( { vectorResourceArchive: true }, '', public_url );
        } ).fail( function( xhr, status ) {
            if ( 'abort' !== status && current_request_id === request_id ) {
                window.location.assign( public_url );
            }
        } ).always( function() {
            if ( current_request_id === request_id ) {
                $archive.removeAttr( 'aria-busy' ).removeClass( 'is-loading' );
                setLoading( false );
                active_request = null;
            }
        } );
    }

    $archive.on( 'click', '[data-resource-market-toggle]', function() {
        var $toggle  = $( this );
        var expanded  = 'true' === $toggle.attr( 'aria-expanded' );
        var $options  = $toggle.closest( '[data-resource-market-group]' ).find( '[data-resource-market-options]' );

        $toggle.attr( 'aria-expanded', expanded ? 'false' : 'true' );
        $options.prop( 'hidden', expanded );
    } );

    $( document ).on( 'click.resourceVideo', '[data-resource-video-trigger]', function( event ) {
        event.preventDefault();
        openVideoModal( $( this ) );
    } );

    $( document ).on( 'click.resourceCardAction', '[data-resource-card-action]', function( event ) {
        if ( $( event.target ).closest( 'a, button, input, select, textarea, label' ).length ) {
            return;
        }

        openResourceCardAction( $( this ) );
    } );

    $( document ).on( 'keydown.resourceCardAction', '[data-resource-card-action]', function( event ) {
        if ( event.target !== this || ( 'Enter' !== event.key && ' ' !== event.key ) ) {
            return;
        }

        event.preventDefault();
        openResourceCardAction( $( this ) );
    } );

    $video_modal.on( 'click.resourceVideo', '[data-resource-video-close]', function() {
        closeVideoModal();
    } );

    $( document ).on( 'keydown.resourceVideo', function( event ) {
        if ( ! $video_modal.length || $video_modal.is( '[hidden]' ) ) {
            return;
        }

        if ( 'Escape' === event.key ) {
            event.preventDefault();
            closeVideoModal();

            return;
        }

        if ( 'Tab' !== event.key ) {
            return;
        }

        var $focusable = getVideoFocusableElements();

        if ( ! $focusable.length ) {
            event.preventDefault();

            return;
        }

        var first = $focusable.get( 0 );
        var last  = $focusable.get( $focusable.length - 1 );

        if ( event.shiftKey && document.activeElement === first ) {
            event.preventDefault();
            last.focus();
        } else if ( ! event.shiftKey && document.activeElement === last ) {
            event.preventDefault();
            first.focus();
        }
    } );

    $archive.on( 'click', '[data-resource-type]', function() {
        var type   = $( this ).attr( 'data-resource-type' ) || '';
        var params = getQueryFromControls();

        if ( type ) {
            params.set( ajax_data.typeFilterQueryVar, type );
        } else {
            params.delete( ajax_data.typeFilterQueryVar );
        }

        requestArchive( params );
    } );

    $archive.on( 'change', '[data-resource-type-select]', function() {
        var type   = $( this ).val() || '';
        var params = getQueryFromControls();

        if ( type ) {
            params.set( ajax_data.typeFilterQueryVar, type );
        } else {
            params.delete( ajax_data.typeFilterQueryVar );
        }

        requestArchive( params );
    } );

    $archive.on( 'submit', '[data-resource-search]', function( event ) {
        if ( ! ajaxIsAvailable() ) {
            return;
        }

        event.preventDefault();
        requestArchive();
    } );

    $archive.on( 'change', '[data-resource-market-filter] input[type="checkbox"]', function() {
        requestArchive();
    } );

    $archive.on( 'click', '[data-resource-filter-clear]', function( event ) {
        if ( ! ajaxIsAvailable() ) {
            return;
        }

        event.preventDefault();
        requestArchive( new URLSearchParams() );
    } );

    if ( $archive.length ) {
        $( window ).on( 'popstate', function() {
            requestArchive( new URLSearchParams( window.location.search ) );
        } );
    }
} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/resource-list.js